module.exports = __webpack_public_path__ + "img/max-file-content-signature-check.cd526f00.svg";